import React from "react";
import { useCurrencyFormatter } from "../../../../Components/Hooks/useCurrencyFormatter";
import CostCard from "./CostCard";

const CARD_MIN = 240;

const CostSummaryBar = ({ data = [] }) => {
  const { formatCurrency } = useCurrencyFormatter();
  if (!data.length) return null;

  const totalMinWidth = data.length * CARD_MIN + (data.length - 1) * 16;

  return (
    <div style={{ overflowX: "auto", marginBottom: 32, WebkitOverflowScrolling: "touch", paddingBottom: 4 }}>
      <div style={{ display: "flex", gap: 16, minWidth: totalMinWidth }}>
        {data.map((item, i) => (
          <div key={item.cost_type_id ?? "total"} style={{ flex: "1 1 0", minWidth: CARD_MIN }}>
            <CostCard
              variant={i === 0 ? "primary" : "default"}
              label={item.cost_type}
              amount={item.amount ?? 0}
              currency={item.currency || "RON"}
              subtitle={i === 0 ? "Confirmed for Disbursement" : undefined}
              formatCurrency={formatCurrency}
              budget={item.budget ?? undefined}
            />
          </div>
        ))}
      </div>
    </div>
  );
};

export default CostSummaryBar;
